function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, NavLink, useLocation } from 'react-router';
import { omit } from 'lodash';

const defaultProps = {
  disabled: false,
  onClick: (_e) => {},
  confirmTitle: '',
  confirmMessage: '',
  replaceNavigationHistory: false
};












const I18NLink = (props) => {
  const {
    to = '/',
    disabled,
    confirmTitle,
    confirmMessage,
    onClick,
    replaceNavigationHistory: replace
  } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const scrollToHashWithRetry = (hash, retries = 10, delay = 100) => {
    if (!hash) return;
    if (retries <= 0) return;
    setTimeout(() => {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        scrollToHashWithRetry(hash, retries - 1, delay);
      }
    }, delay);
  };

  const _navigate = async () => {
    await navigate(to, { replace });
    scrollToHashWithRetry(location.hash);
  };

  const onClickHandler = async (e) => {
    e.preventDefault();
    if (disabled) return;

    if (onClick && confirmTitle) {
      props.mainContext.confirm({
        accept: async () => {
          onClick(e);
          await _navigate();
        },
        title: confirmTitle,
        message: confirmMessage
      });
      return;
    }

    if (onClick) {
      onClick(e);
      await _navigate();
      return;
    }
    await _navigate();
  };

  useEffect(() => {
    scrollToHashWithRetry(location.hash);
  }, [location]);

  const newProps = omit(props, [
  'dispatch',
  'onClick',
  'confirmTitle',
  'confirmMessage',
  'to',
  'activeclassname']
  );

  return (/*#__PURE__*/
    React.createElement(NavLink, _extends({
      end: true,
      to: props.to,
      onClick: onClickHandler,
      className: ({ isActive }) => isActive ? props.activeclassname : undefined },
    newProps)
    ));

};

export function mapStateToProps({ locale }, ownProps) {
  return { to: `/${locale || ''}/${ownProps.to}`.replace(/\/+/g, '/') };
}


export { I18NLink };
export default connect(mapStateToProps)(I18NLink);